import React, { useContext, useMemo } from 'react';
import {
  Button,
  Stack,
  Typography,
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { AuthContext } from '../auth/AuthContext';
import AppShell from '../layouts/AppShell';

const NAV = [
  { key: 'overview', label: 'Overview', icon: <DashboardIcon />, path: '/parent' },
  { key: 'timetable', label: 'Timetable', icon: <CalendarMonthIcon />, path: '/parent/timetable' },
  { key: 'lessons', label: 'Lessons & Assessments', icon: <SchoolIcon />, path: '/parent/lessons' },
  { key: 'billing', label: 'Billing & Documents', icon: <ReceiptLongIcon />, path: '/parent/billing' },
  { key: 'notifications', label: 'Notifications', icon: <NotificationsNoneIcon />, path: '/parent/notifications' },
];

const ParentLayout = ({ children }) => {
  const { user, logout } = useContext(AuthContext) ?? {};

  const navItems = useMemo(
   () =>
      NAV.map((item) => ({
        key: item.key,
        label: item.label,
        path: item.path,
        icon: item.icon,
      })),
    []
  );

  const topRight = (
    <Stack direction="row" spacing={2} alignItems="center">
      <NotificationsNoneIcon />
      <Typography variant="body2" color="text.secondary">
        {user?.name} {user?.surname}
      </Typography>
      <Button variant="outlined" color="error" startIcon={<LogoutIcon />} onClick={logout}>
        Logout
      </Button>
    </Stack>
  );

  return (
    <AppShell
      brand="Parent Portal"
      navItems={navItems}
      headerTitle="Parent Portal"
      topRight={topRight}
      userName={`${user?.name || ''} ${user?.surname || ''}`.trim()}
      userEmail={user?.email || ''}
      userRole="PARENT"
      collapseKey="parentSidebarCollapsed"
    >
      {children}
    </AppShell>
  );
};

export default ParentLayout;
